// extracted by mini-css-extract-plugin
export default {"patentPortal_Search":"Search_patentPortal_Search__yWZ4v"};